/**
 * 新增 修改公用
 */
import popUpEmploye from './view/popUpEmploye.html'
import utils from 'utils'

class parameterConfigurationEditCtrl {
    constructor($scope, httpRequest, $state, $stateParams, formvalidateApi, $uibModal, $timeout, logger, buyerChecker) {
        function reset() {
            $scope.edit = {
                companyName: '', // 名称
                taxNo: '', // 纳税人识别号
                taxBelong: '', // 主管税局所在省市
                pwd: '', // 个税平台登陆密码
                applyType: '2', //申报状态 默认
                employeeNumber: '', // 纳税人类型
                employeeName: '', // 办税员姓名
                logonName: '', //平台登录名称
                shareDir: '', // 办税文件共享路径
                shareUser: '', // 共享文件夹账号
                sharePwd: '', // 共享文件夹密码
                status: 1, //启用
                rpaGroup: '',
                departmentNo: '', //事业部
                regionName: '', //所属大区
                cityName: '', //管理城市
            }
            $scope.params = {
                pageSize: 2000,
                pageNum: 1,
                param: {
                    isRoleOwner: '1', // 拥有本机构角色
                    orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
                },
            }
        }
        function init() {
            reset()
            // 获取所有主管税局信息
            httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                $scope.ProvinceList = res.data.value
            })
            // 字典
            const typecodeArrStr = ['gs_applyType']
            $scope.dictionary = {}
            httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                $scope.dictData = $.extend($scope.dictionary, res.data.value)
            })
            // 获取所有用户信息
            httpRequest.post_usersInfo($scope.params).then((res) => {
                $scope.allUserInfo = res.data.value.list
            })
            // 编辑传过来的id
            const { id } = $stateParams
            if (id) {
                $scope.isEdit = true
                httpRequest.get_getGsConfigById(id).then((res) => {
                    $scope.edit = res.data.value
                    $scope.edit.taxBelong = $scope.edit.province
                    $scope.edit.applyType = String(res.data.value.applyType)
                })
            }
        }
        init()
        // 查询所有纳税人
        $scope.getCompanyNames = function (val) {
            $scope.resetInfor()
            let newVal = ''
            for (var i = 0; i < val.length; i++) {
                newVal = newVal + val.substr(i, 1).replace(/\\/g, '')
            }
            return httpRequest.get_querySaleNameByUserId(newVal).then((res) => {
                return res.data.value
            })
        }
        //将下拉选的数据值赋值给文本框
        $scope.selectTaxName = function (item) {
            $scope.edit.taxNo = item.taxNo
            $scope.edit.taxBelong = item.taxBelong
            $scope.edit.logonName = item.taxNo
            $scope.edit.departmentNo = item.departmentNo
            $scope.edit.regionName = item.regionName
            $scope.edit.cityName = item.cityName
        }
        // 重置信息 搜索时清空
        $scope.resetInfor = function () {
            $scope.edit.taxNo = ''
            $scope.edit.taxBelong = ''
            $scope.edit.logonName = ''
            $scope.edit.departmentNo = ''
            $scope.edit.regionName = ''
            $scope.edit.cityName = ''
        }
        //只能输入0和正整数
        function isRuledNumber(argument) {
            const reg = /^\+?(0|[1-9][0-9]*)$/
            return reg.test(argument)
        }
        // 校验
        $scope.validateRules = {
            taxNo: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            companyName: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            employeeNumber: [
                {
                    erromsg: '办税员工号必填，请检查。',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            employeeName: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        // true 标示显示 errmsg  false 标示验证通过
                        return !value
                    },
                },
            ],
            pwd: [
                {
                    erromsg: '个税平台登录密码变量必填，请检查。',
                    condition(value) {
                        return !value
                    },
                },
            ],
            shareIp: [
                {
                    erromsg: '办税员电脑IP必填，请检查。',
                    condition(value) {
                        return !value
                    },
                },
            ],
            shareDir: [
                {
                    erromsg: '办税文件路径必填，请检查。',
                    condition(value) {
                        return !value
                    },
                },
            ],
            rpaGroup: [
                {
                    erromsg: '校验是否整数',
                    condition(value) {
                        return !isRuledNumber(value)
                    },
                },
            ],
        }
        // 办税员工号弹窗
        $scope.popUpEmploye = function () {
            $uibModal
                .open({
                    template: popUpEmploye,
                    controller: 'popUpEmployeCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal-modaldetails mod-modal mod-modal-hg',
                    resolve: {
                        modalParams() {
                            return {
                                info: $scope.allUserInfo,
                                flag: false,
                            }
                        },
                    },
                })
                .result.then((res) => {
                    getTextByJs(res)
                })
            //拼接字符串
            function getTextByJs(arr) {
                let employeeNumber = ''
                let employeeName = ''
                for (var i = 0; i < arr.length; i++) {
                    employeeNumber += arr[i].userName + ';'
                    employeeName += arr[i].realName + ';'
                }
                //去掉最后一个分号(如果不需要去掉，就不用写)
                if (employeeNumber.length > 0) {
                    employeeNumber = employeeNumber.substr(0, employeeNumber.length - 1)
                }
                if (employeeName.length > 0) {
                    employeeName = employeeName.substr(0, employeeName.length - 1)
                }
                $scope.edit.employeeNumber = employeeNumber
                $scope.edit.employeeName = employeeName
            }
        }
        // 下拉框选择
        $scope.selectUserName = function (item) {
            $scope.edit.employeeName = item.realName
        }
        $scope.$watch('edit.employeeNumber', function (newV, oldV) {
            if (!newV) $scope.edit.employeeName = ''
        })
        const submitHandler = {
            add() {
                //判断名称是否带出税号
                if ($scope.edit.taxNo == '') {
                    logger.logError('纳税人识别号不能为空')
                    return
                } else if ($scope.edit.taxBelong == '') {
                    logger.logError('所属税局不能为空')
                    return
                }
                httpRequest.post_getRpaGsConfigInsert(JSON.stringify($scope.edit)).then((res) => {
                    $scope.encodeURIComponent()
                    logger.logSuccess('参数配置新增成功')
                    $state.go('system.settingcenter.personalTaxConfiguration.list')
                })
            },
            edit() {
                httpRequest.post_getRpaGsConfigEdit($scope.edit).then((res) => {
                    if (res.data.msgCode == 12100) {
                        return
                    }
                    $scope.encodeURIComponent()
                    logger.logSuccess('参数配置修改成功')
                    $state.go('system.settingcenter.personalTaxConfiguration.list')
                })
            },
        }
        // 斜杠编码
        $scope.encodeURIComponent = function () {
            let shareDirStr = $scope.edit.shareDir
            // 判读是否写斜杠 或者只写一个 补全
            if (shareDirStr.charAt(0) !== '\\') {
                shareDirStr = '\\\\' + shareDirStr
            } else if (shareDirStr.charAt(0) == '\\' && shareDirStr.charAt(1) !== '\\') {
                shareDirStr = '\\' + shareDirStr
            }
            //转义替换;
            let encode = shareDirStr.replace(/\\/g, encodeURIComponent('\\'))
            $scope.edit.shareDir = encode
        }
        // 修改 新增并继续
        $scope.submit = function (method) {
            const mark = formvalidateApi.run()
            if (!mark) {
                return
            }
            submitHandler[method]()
        }
        $scope.cancle = function () {
            $state.go('system.settingcenter.personalTaxConfiguration.list')
        }
    }
}
parameterConfigurationEditCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'formvalidateApi', '$uibModal', '$timeout', 'logger', 'buyerChecker']
export default parameterConfigurationEditCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/personalTaxConfiguration/parameterConfigurationEditCtrl.js